import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faEye, faUserCheck, } from "@fortawesome/free-solid-svg-icons";
import { Form, Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import { useEffect, useState } from "react";
import SrvButtonLink from "../global/SrvButtonLink";
import SrvButton from "../global/SrvButton";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import "./CardUserAvailable.css"
import AvatarRound from "../AvatarRound";
import { loadUser as loadProjectUser } from '../../reducers/models/project/projectList'

function CardUserAvailable({ checkedList, changeHandler, all, allHandler, maxShow }) {
    //checkedList = [1,2] - Список выбранных пользователей
    //all - Выбраны все пользователи или нет
    //maxShow - Максимальное кол-во отображаемых пользователей

    //console.log('all', all)

    const dispatch = useDispatch()

    const stateUserList = useSelector((state) => state.userList);//Пользователи   
    const stateSize = useSelector((state) => state.size);//Размеры окна

    const [log, setLog] = useState(false);
    const [loading, setLoading] = useState(false);
    const [modalEdit, setModalEdit] = useState(false);
    const [users, setUsers] = useState([]);
    const [showAll, setShowAll] = useState(false);

    useEffect(() => {
        //Владелец и Админы
        setUsers(stateUserList.list.filter(a => a.ID_Role === 0 || a.ID_Role === 1))
        //Добавленные пользователи

        const users_ =
            checkedList.map(item => {
                if (stateUserList.list.filter(a => a.ID_Role === 2 & a.ID_User === item).length > 0) {
                    setUsers(prevValue => [...users, stateUserList.list.filter(a => a.ID_Role === 2 & a.ID_User === item)[0]])
                }
            })

    }, [checkedList]);


    return (
        <>
            {all === true ? (
                <>
                    <div style={{ display: 'flex' }}>
                        <div style={{ marginLeft: 'auto' }}>
                            <SrvButtonLink typeBtn="edit" textBtn="" onClick={() => setModalEdit(true)} />
                        </div>

                    </div>
                    <div>Все пользователи</div>
                </>
            ) : (
                <>
                    {stateSize.desktop === true ? (
                        <div className="card_widget_body">
                            <div className="card_widget_btn_edit">
                                <SrvButtonLink typeBtn="edit" textBtn="" onClick={() => setModalEdit(true)} />
                            </div>
                            {users.map((user, index) => (
                                showAll === true ? (
                                    <div key={user.ID_User} className="card_user_row">
                                        <div><AvatarRound img={user.Avatar} width={30} name={user.User_Name} /></div>
                                        <div className="ml-5">
                                            <div className="title">{user.Name_User}</div>
                                            <div className="subtitle">{user.Name_Role}</div>
                                        </div>
                                    </div>
                                ) : (
                                    index < maxShow && (
                                        <div key={user.ID_User} className="card_user_row">
                                            <div><AvatarRound img={user.Avatar} width={30} name={user.User_Name} /></div>
                                            <div className="ml-5">
                                                <div className="title">{user.Name_User}</div>
                                                <div className="subtitle">{user.Name_Role}</div>
                                            </div>
                                        </div>
                                    )
                                )
                            ))}
                            {users.length > maxShow && (
                                showAll === false ? (
                                    <div className="user_list_item_else" onClick={(e) => setShowAll(true)}>Показать еще {users.length - maxShow}</div>
                                ) : (
                                    <div className="user_list_item_else" onClick={(e) => setShowAll(false)}>Скрыть</div>
                                )
                            )}
                        </div>
                    ) : (
                        <div className="card_widget_body">
                            <div style={{ display: 'flex' }}>
                                <div style={{ marginLeft: 'auto' }}>
                                    <SrvButtonLink typeBtn="edit" textBtn="" onClick={() => setModalEdit(true)} />
                                </div>

                            </div>
                            <div className="m_card_user_row">
                                {users.map((user, index) => (
                                    <div key={user.ID_User} className="m_card_user_row_item">
                                        <div><AvatarRound img={user.Avatar} width={30} name={user.User_Name} /></div>
                                        <div className="ml-5">
                                            <div className="title">{user.Name_User}</div>
                                            <div className="subtitle">{user.Name_Role}</div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )
                    }
                </>
            )}
            {
                modalEdit === true && (
                    <Modal show={modalEdit} onHide={() => setModalEdit(false)} size="">
                        <Modal.Body>
                            <div className="modal_title text-center">Выбор исполнителей</div>
                            <div className="p-2 mt-5 ">
                                <Form.Check
                                    type="switch"
                                    id="custom-switch"
                                    label="Все пользователи"
                                    defaultChecked={all}
                                    onChange={(val) => allHandler(val.target.checked)}
                                />
                            </div>
                            <div className="mb-15">
                                {stateUserList.list.map((model) => (
                                    <div key={model.ID_User} className="list_item row_select mt-10">
                                        <div><AvatarRound img={model.Avatar} width={30} name={model.Name_User} /></div>
                                        <div className="ml-10" style={{ width: '100%' }}>
                                            <div className="title"> {model.Name_User} {model.ID_User}</div>
                                            <div className="subtitle"> {model.Name_Role}</div>
                                        </div>
                                        <div className="end">
                                            <OverlayTrigger
                                                placement="top"
                                                overlay={
                                                    <Tooltip id='tooltip-top'>
                                                        Выбрать
                                                    </Tooltip>
                                                }
                                            >
                                                {all === true ? (
                                                    <button disabled={true}
                                                        className="btn btn-sm btn-dashed btn-outline-secondary ml-10" >
                                                        <FontAwesomeIcon icon={faCheck} className="mr-5-" />
                                                    </button>
                                                ) : (
                                                    <button disabled={model.ID_Role === 2 ? false : true}
                                                        onClick={() => model.ID_Role === 2 && changeHandler(users.filter(a => a.ID_User === model.ID_User).length > 0 ? false : true, model.ID_User)}
                                                        className={users.filter(a => a.ID_User === model.ID_User).length > 0 ? "btn btn-sm btn-dashed btn-outline-secondary ml-10 active" : "btn btn-sm btn-dashed btn-outline-secondary ml-10"} >
                                                        <FontAwesomeIcon icon={faCheck} className="mr-5-" />
                                                    </button>
                                                )}
                                            </OverlayTrigger>
                                        </div>
                                    </div>
                                ))
                                }
                            </div>
                            {log != null && (
                                <div className="form_error text-center">
                                    {log}
                                </div>
                            )}
                        </Modal.Body>
                    </Modal>
                )
            }
        </>
    )
}

export default CardUserAvailable;